import React, {PropTypes, Component} from 'react';
import {connect} from 'react-redux';
import {showEditQuestion} from '../modules/Navigation';
import {getQuestionVotes, updateQuestion, deleteQuestion, moderateQuestion, lockQuestion} from '../modules/Question';
import {addComment, showAllComments} from '../modules/Question-Comments';
import {getUser} from '../modules/Authenticate';
import AnswerList from './AnswerList';
import CommentList from './CommentList';
import answerFormCreator from './AnswerForm';
import TagList from './TagList';
import {emitPageView, emitEvent} from '../lib/mz';
import AcceptedAnswer from './components/AcceptedAnswer';
import UserComment from './components/UserComment';
import PostControls from './components/PostControls';
import VoteControl from './components/VoteControl';
import IconStatList from './components/IconStatList';
import IconStat from './components/IconStat';
import A from './components/A';

@connect(
  (state) => ({
    questionVotes: state.question.questionVotes,
    context: state.environment.widgetConfig.context,
    contextType: state.environment.widgetConfig.contextType,
  }),
  {
    showEditQuestion,
    getQuestionVotes,
    updateQuestion,
    moderateQuestion,
    deleteQuestion,
    lockQuestion,
    getUser,
    addComment,
    showAllComments,
  }
)

// eslint-disable-next-line react/prefer-stateless-function
export default class Question extends Component {
  static propTypes = {
    question: PropTypes.object.isRequired,
    questionVotes: PropTypes.object,
    user: PropTypes.object,
    getUser: PropTypes.func.isRequired,
    getQuestionVotes: PropTypes.func,
    showEditQuestion: PropTypes.func.isRequired,
    addComment: PropTypes.func.isRequired,
    showAllComments: PropTypes.func.isRequired,
    voteUp: PropTypes.func.isRequired,
    voteDown: PropTypes.func.isRequired,
    updateQuestion: PropTypes.func.isRequired,
    moderateQuestion: PropTypes.func.isRequired,
    deleteQuestion: PropTypes.func.isRequired,
    lockQuestion: PropTypes.func.isRequired,
    widget: PropTypes.bool,
    widgetType: PropTypes.string,
    context: PropTypes.string,
    contextType: PropTypes.string,
  };

  componentDidMount() {
    this.props.getQuestionVotes(this.props.question.id);
    if (!this.props.widget) {
      emitPageView({id: this.props.question.id, type: 'question'});
    }
  }

  render() {
    const {question, voteUp, voteDown, user, questionVotes, widget, widgetType} = this.props;
    const mzClick = (eventTitle) =>
      emitEvent('CLICK', {eventTitle, module: {type: widgetType}});

    const onEditClick = (e) => {
      e.preventDefault();
      this.props.showEditQuestion(question.id);
    };

    const onDeleteClick = (e) => {
      e.preventDefault();
      mzClick('question-delete');
      this.props.deleteQuestion({id: question.id, deleted: true});
    };

    const onUndoDeleteClick = () => {
      mzClick('question-delete-undo');
      this.props.deleteQuestion({id: question.id, deleted: false});
    };

    const onAddCommentClick = (e) => {
      e.preventDefault();
      mzClick('question-add-comment');
      this.props.addComment('question', question.id, true);
    };

    const onCloseCommentClick = (e) => {
      e.preventDefault();
      mzClick('question-close-comment');
      this.props.addComment('question', question.id, false);
    };

    const onModerateClick = (e) => {
      e.preventDefault();
      mzClick('question-moderate');
      this.props.moderateQuestion({id: question.id, moderated: true});
    };

    const onUndoModerateClick = (e) => {
      e.preventDefault();
      mzClick('question-moderate-undo');
      this.props.moderateQuestion({id: question.id, moderated: false});
    };

    const onLockClick = (e) => {
      e.preventDefault();
      mzClick('question-lock');
      this.props.lockQuestion({id: question.id, locked: true});
    };

    const onUndoLockClick = (e) => {
      e.preventDefault();
      mzClick('question-lock-undo');
      this.props.lockQuestion({id: question.id, locked: false});
    };

    const onLoadOlderCommentsClick = () => {
      this.props.showAllComments({parentType: 'question', parentId: question.id, showComments: true});
    };

    const noop = () => {};

    const isUsersQuestion = user && question.user_id === user.id;
    const userIsModerator = user && user.canModerate;
    const canEdit = isUsersQuestion || userIsModerator;
    const questionLM = question.moderated || question.locked;
    const questionDLM = question.deleted || questionLM;

    const buttonDisabled = isUsersQuestion || questionDLM;
    const voteStatus = questionVotes.question && questionVotes.question.vote ? questionVotes.question.vote : '';

    const AnswerForm = answerFormCreator('newAnswer');
    const newAnswerForm = questionDLM ? null : (
      <div className="posting-grid posting-grid--top-border margin-bottom-md margin-bottom-lg-screen-sm">
        <div className="posting-grid__content">
          <div className="t-question-answer-form question-answer-form">
            <UserComment userId={user && user.id} username={user && user.username} showText={false} layout="column">
              <AnswerForm
                isUsersQuestion={isUsersQuestion} question={question} widget={widget}
                widgetType={widgetType}
              />
            </UserComment>
          </div>
        </div>
      </div>);

    const pluralize = (word, number) => (number === 1 ? word : `${word}s`);

    const commentCount = question.comments
      ? `${question.comments.length} ${pluralize('Comment', question.comments.length)}`
      : (<A className="t-comment-add" onClick={onAddCommentClick}>
          Add comment
        </A>);

    const editQuestionButton = canEdit && !questionDLM ? (
      <div className="link link--colored t-question-edit-btn" onClick={onEditClick}>
        Edit
      </div>
    ) : null;

    const deleteQuestionButton = canEdit && !questionLM && !question.deleted ? (
      <div className="link link--colored t-question-delete-btn" onClick={onDeleteClick}>
        Delete
      </div>
    ) : null;

    const undeleteQuestion = canEdit && !questionLM && question.deleted ? (
      <div className="link link--colored t-question-undelete-btn" onClick={onUndoDeleteClick}>
        Undo Delete
      </div>
    ) : null;

    const moderateQuestionButton = userIsModerator && !question.moderated ? (
      <div className="link link--colored t-question-moderate-btn" onClick={onModerateClick}>
        Moderate
      </div>
    ) : null;

    const undoModerateQuestionButton = userIsModerator && question.moderated ? (
      <div className="link link--colored t-question-unmoderate-btn" onClick={onUndoModerateClick}>
        Un-moderate
      </div>
    ) : null;

    const lockQuestionButton = userIsModerator && !question.locked && !question.moderated ? (
      <div className="link link--colored t-question-lock-btn" onClick={onLockClick}>
        Lock
      </div>
    ) : null;

    const undoLockQuestionButton = userIsModerator && question.locked && !question.moderated ? (
      <div className="link link--colored t-question-unlock-btn" onClick={onUndoLockClick}>
        Unlock
      </div>
    ) : null;

    const deletedStyle = question.deleted ? {textDecoration: 'line-through'} : null;
    const isCommentType = widgetType === 'comment';

    const questionContent = isCommentType ? null : (
      <div className="posting-grid posting-grid--bottom-padding">
        <div className="posting-grid__controls">
          { !questionDLM &&
            <div>
              {question.accepted_answer_id && <div className="margin-bottom-xs"><AcceptedAnswer text="Answered" /></div>}
              <div className="margin-bottom-xs">
                <VoteControl
                  votesType="question"
                  value={question.votes_total}
                  onVoteUpClick={!isUsersQuestion ? voteUp : noop}
                  onVoteDownClick={!isUsersQuestion ? voteDown : noop}
                  isDisabled={buttonDisabled}
                  voteStatus={voteStatus}
                />
              </div>
              <IconStatList>
                <IconStat key="views" name="views" icon="views" value={question.views} />
                <IconStat key="answers" name="answers" icon="bubble" value={question.answer_count} />
              </IconStatList>
            </div>
          }
        </div>
        <div className="posting-grid__content">
          <div className="t-question-container question-item">
            <div className="question-item__body">
              <h1 className="heading heading--md heading--bold margin-bottom-sm break-lengthy-words t-question-header">
                {question.moderated && <span className="header-tag">Moderated</span>}
                {question.locked && <span className="header-tag header-tag--closed">Locked</span>}
                {question.deleted && <span className="header-tag">Deleted</span>}
                {question.title}
              </h1>
              <UserComment userId={question.user_id} username={question.username} when={question.createdHuman}>
                <div
                  style={deletedStyle}
                  className="t-question-content question-item__content"
                  dangerouslySetInnerHTML={{__html: question.content_rendered}}
                />
                <TagList tags={question.tags.join(',')} />
              </UserComment>
            </div>
            <div className="question-item__footer">
              <PostControls>
                <span>{commentCount}</span>
                {editQuestionButton}
                {deleteQuestionButton}
                {undeleteQuestion}
                {moderateQuestionButton}
                {undoModerateQuestionButton}
                {lockQuestionButton}
                {undoLockQuestionButton}
              </PostControls>
              <CommentList
                question={question}
                comments={question.comments}
                user={user}
                showAllComments={question.showComments}
                onLoadOlderCommentsClick={onLoadOlderCommentsClick}
                onAddCommentClick={onAddCommentClick}
                onCloseCommentClick={onCloseCommentClick}
              />
            </div>
          </div>
        </div>
      </div>);

    return (
      <div>
        {questionContent}
        <hr className="content-breaker" />
        <AnswerList question={question} questionVotes={questionVotes} user={user} widgetType={widgetType} />
        {newAnswerForm}
      </div>
    );
  }
}
